import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';

@Component({
  template: `
    <fl-bit class="Header">
      <fl-heading
        i18n="Close course modal header"
        [size]="HeadingSize.XSMALL"
        [headingType]="HeadingType.H4"
        [flMarginBottom]="Margin.SMALL"
      >
        Close your course
      </fl-heading>
    </fl-bit>
    <fl-bit class="MainBody">
      <fl-text
        i18n="Close course modal body"
        [flMarginBottom]="Margin.SMALL"
      >
        Once you close the course, you will no longer be able to publish it.
      </fl-text>
    </fl-bit>
    <div class="ActionContainer">
      <fl-button class="ActionButton"
        i18n="Close course modal cancel button"
        [color]="ButtonColor.DEFAULT"
        [flMarginRight]="Margin.SMALL"
        (click)="cancel()"
      >
        Cancel
      </fl-button>
      <fl-button class="ActionButton"
        i18n="Close course modal close button"
        [color]="ButtonColor.SECONDARY"
        (click)="confirm()"
      >
        Close
      </fl-button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./confirm-close-course-modal.scss'],
})
export class ConfirmCloseCourseModalComponent {
  Margin = Margin;
  BannerAlertType = BannerAlertType;
  ButtonColor = ButtonColor;
  HeadingSize = HeadingSize;
  HeadingType = HeadingType;

  constructor(private modalRef: ModalRef<ConfirmCloseCourseModalComponent>) {}

  confirm() {
    this.modalRef.close(true);
  }

  cancel() {
    this.modalRef.close(false);
  }
}
